import {Typography} from '~library/atoms/Typography';
import {ArrowIcon} from '~library/svg/ArrowIcon';
import {Button} from '~library/atoms/Button';

type SkipButtonProps = {
  onClick: () => void;
};

export const SkipButton = ({onClick}: SkipButtonProps) => (
  <Button
    variant="unstyled-button"
    onClick={onClick}
    data-qa-id="skip-button"
    className="rsvp-header__skip-button"
  >
    <Typography variant="label2">NEXT</Typography>
    <ArrowIcon direction="right" ratio={0.75} />
  </Button>
);
